import { useEffect, useState } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import { initLenis, scrollToId } from "@/lib/scroll";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Kindergartens from "@/components/Kindergartens";
import { About, EnglishDaily, Methodologies, ArtTherapy } from "@/components/Sections";
import Development from "@/components/Development";
import Nutrition from "@/components/Nutrition";
import Services from "@/components/Services";
import LeadForm from "@/components/LeadForm";
import Footer from "@/components/Footer";
import Assistant from "@/components/Assistant";

export default function App() {
  const [activePortal, setActivePortal] = useState(null);
  const [formKindergarten, setFormKindergarten] = useState(null);

  useEffect(() => {
    initLenis();
  }, []);

  const enroll = (k) => {
    setActivePortal(null);
    setFormKindergarten(k);
    setTimeout(() => scrollToId("forma"), 80);
  };

  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <Header />
      <main className="relative z-[2]">
        <Hero />
        <Kindergartens active={activePortal} setActive={setActivePortal} onEnroll={enroll} />
        <About />
        <EnglishDaily />
        <Development />
        <Methodologies />
        <ArtTherapy />
        <Nutrition />
        <Services />
        <LeadForm selected={formKindergarten} setSelected={setFormKindergarten} />
        <Footer />
      </main>
      <Assistant />
    </div>
  );
}
